"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSelectTheme = void 0;
exports.createSelectTheme = function (_a) {
    var palette = _a.palette;
    return {
        root: {},
        selectMenu: {
            borderRadius: 32,
            "&:focus": {
                borderRadius: 32,
                background: palette.common.white,
            },
        },
    };
};
